export function snakeCaseToCamelCase(value: string) {
  return value.replace(/([-_][a-z0-9])/gi, $1 => {
    return $1.toUpperCase().replace('-', '').replace('_', '');
  });
}

export function snakeCaseToPascalCase(value: string) {
  const camelCase = snakeCaseToCamelCase(value);
  const pascalCase = camelCase[0].toUpperCase() + camelCase.substring(1);
  return pascalCase;
}

export function camelCaseToSnakeCase(value: string) {
  return value.replace(/([A-Z0-9])/g, $1 => {
    return `_${$1.toLowerCase()}`;
  });
}

export function pascalCaseToSnakeCase(value: string) {
  return camelCaseToSnakeCase(value[0].toLowerCase() + value.substring(1));
}
